<template>
    <div class="ur-data-grid__table" :style="tableStyle" :class="tableClass" ref="table" tabindex="-1" 
            @keydown="keydownTable" v-click-outside="cancelEdit">
        <!-- HEADER -->
        <component :is="headerCompo"/>
        <!-- CONTENT -->
        <grid-content/>
        <!-- SUMMARY -->
        <grid-summary/>
        <!-- Additional funciton -->
        <grid-blocker v-if="gridInfo.vars_onBlocking"/>
        <grid-noti ref="noti"/>
        <grid-context ref="context"/>
        <div class="ur-data-grid__resize-guide" :style="guideStyle"/>
        <textarea class="ur-data-grid__clipboard-holder" ref="clipboard"/>
    </div>
</template>


<script>
import gridHeader  from '../header/urDataGridHeader.vue';
import slotHeader  from '../header/urDataGridSlotHeader.js';
import gridContent from '../content/urDataGridContent.js';

import gridNoti    from './module/urDataGridNoti.vue';
import gridBlocker from './module/urDataGridBlocker.vue';
import gridContext from './module/urDataGridContext.vue';
import gridSummary from './module/urDataGridSummary.js';


import clickOutside from '../common/direc/urDataGridClickOutside.js'
import {_rafThrottle} from '../util';

export default {
    name : 'urDataGridTable',
    inject : ["gridInfo"],
    components : {gridContent, gridNoti, gridBlocker, gridContext, gridSummary},
    computed : {
        // [COMPUTED] Flag, 높이를 가지고 있습니까?
        hasHeight () { return !!this.gridInfo.opts.height; },
        // [COMPUTED] Value, 테이블의 높이
        tableHeight() {
            if(this.hasHeight) {
                return this.gridInfo.opts.height+'px';
            } else {
                return 'auto';
            }
        },
        // [COMPUTED] Style, 테이블의 높이
        tableStyle() {return {
            'height': this.tableHeight
        }},
        // [COMPUTED] Style, 가이드 라인의 위치(Column resize)
        guideStyle() {return {
            'left'   : this.gridInfo.vars_resizeGuide+'px',
            'display': this.gridInfo.vars_resizeGuide<=0?'none':'block'
        }},
        // [COMPUTED] Style, 테이블의 클래스 지정
        tableClass() {
            var clazz = []
            if(this.gridInfo.opts.styleBordered) clazz.push('ur-data-grid__table__bordered')
            return clazz;
        },
        // [COMPUTED] Component, Custom Header 여부
        headerCompo() {
            if(this.gridInfo.slot['header']) {
                return slotHeader;
            } else {
                return gridHeader;
            }
        },
    },
    mounted() {
        this.gridInfo.func.setRefs('table'    ,this.$refs.table);
        this.gridInfo.func.setRefs('context'  ,this.$refs.context);
        this.gridInfo.func.setRefs('clipboard',this.$refs.clipboard);
        
    },
    methods: {
        // [METHOD] Event, 테이블 키 입력, (tabIndex 필요 => focus)
        
        keydownTable: /*NOSONAR*/function(e){
            const keyCode = e.keyCode;
            const KEYCODE = this.gridInfo.CONST.KEYCODE;
            const onEdit  = this.gridInfo.vars_cSelOnEdit;
            // 1. prepass, freepass?
            if( KEYCODE.SHIFT === keyCode ||
                KEYCODE.CTRL  === keyCode ||
                KEYCODE.ALT   === keyCode) return;
            if(this.gridInfo.opts.cellMode) {
                switch(keyCode) {
                case KEYCODE.LEFT:
                case KEYCODE.RIGHT:
                case KEYCODE.UP:
                case KEYCODE.DOWN:
                    if(onEdit) break; // READ-MODE only
                    e.preventDefault();
                    this.gridInfo.func.moveCellSelect(keyCode, e.ctrlKey, e.shiftKey)
                    break;
                case KEYCODE.ENTER:
                    if(onEdit) {
                        // ENTER.EDIT-MODE
                        // ENTER.1 Save cell
                        var res = this.gridInfo.func.saveCell();
                        // ENTER.2 Move next & edit again
                        if(res) {
                            // ENTER.2.1 Move next
                            var prevIdx = this.gridInfo.vars_cSelIdxSt;
                            this.gridInfo.func.moveCellSelect(e.shiftKey ? KEYCODE.UP : KEYCODE.DOWN)
                            // ENTER.2.2 Success move? Edit. Fail? esc.
                            if(this.gridInfo.opts.keepEditable && prevIdx !== this.gridInfo.vars_cSelIdxSt) {
                                this.gridInfo.func.editCell();
                            } else {
                                this.tableFocus();
                            }
                        } /**/
                    } else {
                        // ENTER.READ-MODE
                        this.gridInfo.func.moveCellSelect( e.shiftKey ? KEYCODE.UP : KEYCODE.DOWN);
                    }
                    break;
                case KEYCODE.F2:
                    this.gridInfo.func.editCell();
                    break;
                case KEYCODE.ESC:
                    if(onEdit) {
                        this.gridInfo.func.cancelCell();
                        this.tableFocus();
                    }
                    if(this.gridInfo.vars_cClipboard) {
                        this.gridInfo.func.clearClipboard();
                    }
                    break;
                //case KEYCODE.DEL:
                    //if(onEdit) break; // READ-MODE only
                    //this.gridInfo.func.deleteCellData();
                    //break;
                case KEYCODE.TAB:
                    if(onEdit) {
                        // TAB.EDIT-MODE
                        // TAB.1 Prevent default
                        e.preventDefault();
                        // TAB.2 Save previous
                        let res = this.gridInfo.func.saveCell();
                        // TAB.3 Move next & edit again
                        if(res) {
                            // TAB.3.1 Move next
                            var prevFil = this.gridInfo.vars_cSelFilSt;
                            this.gridInfo.func.moveCellSelect(e.shiftKey ? KEYCODE.LEFT : KEYCODE.RIGHT)
                            // TAB.3.2 Success move? Edit. Fail? esc.
                            if(this.gridInfo.opts.keepEditable && prevFil !== this.gridInfo.vars_cSelFilSt) {
                                this.gridInfo.func.editCell();
                            } else {
                                this.tableFocus();
                            }
                        }
                    } else {
                        // TAB.READ-MODE
                        // TAB.1 Prevent default
                        e.preventDefault();
                        // TAB.2 Move next
                        this.gridInfo.func.moveCellSelect(e.shiftKey ? KEYCODE.LEFT : KEYCODE.RIGHT)
                    }
                    break;
                case KEYCODE.HOME:
                    if(onEdit) break; // READ-MODE only
                    e.preventDefault();
                    this.gridInfo.func.moveCellSelect(KEYCODE.LEFT,true, e.shiftKey)
                    break;
                case KEYCODE.END:
                    if(onEdit) break; // READ-MODE only
                    e.preventDefault();
                    this.gridInfo.func.moveCellSelect(KEYCODE.RIGHT,true, e.shiftKey)
                    break;
                case KEYCODE.PAGEUP:
                    if(onEdit) break; // READ-MODE only
                    e.preventDefault();
                    this.gridInfo.func.moveCellSelect(KEYCODE.PAGEUP, e.ctrlKey, e.shiftKey)
                    break;
                case KEYCODE.PAGEDOWN:
                    if(onEdit) break; // READ-MODE only
                    e.preventDefault();
                    this.gridInfo.func.moveCellSelect(KEYCODE.PAGEDOWN, e.ctrlKey, e.shiftKey)
                    break;
                default:
                    // ETC... keyCode
                    if(!onEdit) {
                        // Other functional key
                        if(e.key.length !== 1) break;
                        // Copy & Paste
                        if(e.ctrlKey && e.key === 'c') {         // CTRL+C : Copy selected
                            this.gridInfo.func.copyToClipboard();
                        } else if(e.ctrlKey && e.key === 'v') {  // CTRL+V : Paste to
                            if(this.gridInfo.opts.rowEdit || this.gridInfo.opts.cellEdit) {
                                this.gridInfo.func.setPasteData();
                            }
                        } else if(e.ctrlKey && e.key === 'a') {  // CTRL+A : Select all data
                            this.gridInfo.func.selectAllData();
                            e.preventDefault();
                        } else if (e.ctrlKey || e.altKey) {
                            // NO OP.
                        }else {
                            this.gridInfo.func.editCell();
                        }
                    }
                }
            }
        },
        // [METHOD] Util, Focus me!
        tableFocus() {
            this.$el.focus();
        },
        // [METHOD] Util, Cancel cellEdit
        cancelEdit() {
            if(!this.gridInfo.vars_cSelOnEdit) {return}
            if( this.gridInfo.vars_cOnFlotage) {return}
            this.gridInfo.func.saveCell();
        },
    },
    directives: {'click-outside': clickOutside}
}

</script>